export function getXMonthsAgoDate(month: number) {
    const todaysDate = new Date();
    //instancia um objeto date de 3 meses antes da data de hoje
    return new Date(new Date().setMonth(todaysDate.getMonth() - month));
}

export function getMonthOpenOrCloseDate(
    date: Date,
    month: number,
    closeDate = false
) {
    const cloneDate = new Date(date);
    cloneDate.setMonth(date.getMonth() + month);
    if (closeDate) {
        cloneDate.setDate(31);
        cloneDate.setHours(23, 59, 59, 999);
    } else {
        cloneDate.setDate(1);
        cloneDate.setHours(0, 0, 0, 0);
    }
    return cloneDate;
}
